import { DataCapsule, LocalStorageStrategy, NOT_FOUND, COOKIE_CONSENT_DISALLOWED } from 'data-capsule';
export const NAMESPACE = 'media-manager-sdk';
export const DEFAULT_EXPIRATION = 315360000000;
export const DataStorageError = {
  NotFound: NOT_FOUND,
  NotAllowed: COOKIE_CONSENT_DISALLOWED
};
export const DataCategory = {
  Essential: 'essential',
  Functional: 'functional',
  Analytics: 'analytics',
  Advertising: 'advertising'
};
class DataStorage {
  constructor() {
    this.capsule = new DataCapsule({
      strategy: new LocalStorageStrategy(),
      namespace: NAMESPACE
    });
  }
  setItem(key, value, expiration, category) {
    if (value === void 0) {
      value = null;
    }
    if (expiration === void 0) {
      expiration = DEFAULT_EXPIRATION;
    }
    if (category === void 0) {
      category = DataCategory.Functional;
    }
    return this.capsule.setItem(key, value, {
      expiration,
      category
    });
  }
  getItem(key) {
    return this.capsule.getItem(key);
  }
  removeItem(key) {
    return this.capsule.removeItem(key);
  }
}
export const dataStorage = new DataStorage();